export default __webpack_public_path__ + "static/media/LUNA.6767c7f8.png";